import script from "./depositZarPopup.vue?vue&type=script&setup=true&lang=js"
export * from "./depositZarPopup.vue?vue&type=script&setup=true&lang=js"

import "./depositZarPopup.vue?vue&type=style&index=0&id=680e9998&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-680e9998"]])

export default __exports__